import { h } from 'preact';
// eslint-disable-next-line react/no-deprecated
import { render } from 'react';

(() => {
  window.h = h;
  window.render = render;
})();
